import React from 'react'
import { Box, Checkbox, FormControlLabel, FormGroup, FormGroupProps } from '@mui/material'
import { useTranslation } from 'react-i18next';

interface IProps {
}

const IncompleteModal = React.forwardRef((_: IProps, ref: React.ForwardedRef<any>) => {
    const { t } = useTranslation();
    const [personal, setPersonal] = React.useState<boolean>(false);
    const [org, setOrg] = React.useState<boolean>(false);
    const [request, setRequest] = React.useState<boolean>(false);
    const [record, setRecord] = React.useState<boolean>(false);

    React.useImperativeHandle(ref, () => ({

        getStep(): number {
            if (personal && org && request && record) return -1;
            if (personal) return 0;
            if (org) return 1;
            if (request) return 2;
            if (record) return 3
            return 25;
        }
    }));

    const formGroupProps: FormGroupProps = {
        sx: {
            display: 'inline-flex',
            flexDirection: 'row',
        }
    }

    return (
        <Box>
            <FormGroup {...formGroupProps}>
                <FormControlLabel sx={{width: '45%'}} control={<Checkbox checked={personal} onChange={() => setPersonal(!personal)} />} label={t('steps.step1')} />
                <FormControlLabel sx={{width: '45%'}} control={<Checkbox checked={request} onChange={() => setRequest(!request)} />} label={t('steps.step3')} />
                <FormControlLabel sx={{width: '45%'}} control={<Checkbox checked={org} onChange={() => setOrg(!org)} />} label={t("steps.step2")} />
                <FormControlLabel sx={{width: '45%'}} control={<Checkbox checked={record} onChange={() => setRecord(!record)} />} label={t('steps.step4')} />
            </FormGroup>
        </Box>
    )
});

export default IncompleteModal;